export const RadarCard = ({ children }: { children: React.ReactNode }) => (
  <div className="bg-canvas-tertiary-main flex-1 p-4">{children}</div>
);
